import { Component, OnInit, ViewChild, ElementRef,
    Input, Output, EventEmitter } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { VcaAlertsService } from '../../../../../common/vca-alerts';
import {VcaGrid} from '../../../../../common/vca-grid/vca-grid.component';
import { NgForm } from '@angular/forms';
import { Observable }  from 'rxjs/Observable';
import { Subscription } from 'rxjs/Rx';

import { Response } from '@angular/http';
const _ = require('lodash');
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';

import InventoryTreeHolder from '../../../dataprotection/dataprotection-vc/dataprotection-tree/tree-holder/tree-holder.component';
import InventoryTreeVC from '../../../dataprotection/dataprotection-vc/dataprotection-tree/tree-vc/tree-vc.component';


import { DataPasserService } from '../data-passer/data-passer.service';
import { DataPasser } from '../data-passer/data-passer';

@Component({
    selector: 'select-entity-dialog-component',
    template: require('./select-entity-dialog.html'),
    styles: [require('../dc.scss')],
    providers: [
        TranslateService, DataPasserService
      ]
})


export class SelectEntityDialogComponent {
    @Input() isDialogOpen: boolean;
    @Input() entityType: string;
    @Input() vcenterId: string;
    @Input() nodeToBeSelectedOnLoad: string = '';
    @Input() skipNodeType: string = '';
    @Input() title: string;
    @Output('cancel') cancelEventEmitter = new EventEmitter();
    @Output('save') saveEventEmitter = new EventEmitter();
    private dialogTitle: string = '';
    private dataModel = {
        name: '',
        id: '',
        owner: {}
    }
    private data: DataPasser = { entity_id: '', type: '', name: '', vcenter_instanceId: '', vcHost: '', owner: {}};
    constructor(private router: Router,
      private alert: VcaAlertsService, private activatedRoute: ActivatedRoute, private translate: TranslateService,
      public passer: DataPasserService) {
        translate.use(GlobalVariables.LOCALE);
        this.resetDataModel();
        this.passer.getData().subscribe(data => {
            if (data.entity_id && data.name && data.type !== this.skipNodeType) {
                this.dataModel.id = data.entity_id;
                this.dataModel.name = data.name;
                this.dataModel.owner = data.owner;
            } else {
                this.dataModel.id = '';
                this.dataModel.name = '';
                this.dataModel.owner = '';
            }

        });
    }

    ngOnInit() {

    }

    resetDataModel() {
        this.dataModel = {
            name: '',
            id: '',
            owner: {}
        }
    }
    ngOnChanges() {
        if (!this.entityType) {
            return;
        }
        if(this.title){
            this.dialogTitle = this.title;
        } else {
            this.dialogTitle = this.translate.instant('vcAdministration.' + this.entityType);
        }
    }

    onCancel() {
        this.isDialogOpen = false;
        this.cancelEventEmitter.emit();
    }

    saveDeploymentContainer() {
        this.isDialogOpen = false;
        this.emitSavedData();
    }

    emitSavedData() {
        if (this.saveEventEmitter) {
            this.saveEventEmitter.emit({
               'data': this.dataModel,
               'entityType': this.entityType
            });
         }
    }
    onGlobalSelect(event) {
    }
}




// WEBPACK FOOTER //
// ./src/app/components/administration-main/deployment-container/dialog/select-entity-dialog.component.ts